import styled from 'styled-components';

export const LabelWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

export const ValueWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: right;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;
